import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { t } = useTranslation();
  const faqs = t('faq.questions', { returnObjects: true });
  
  return (
    <section className="py-24 px-6 bg-dark-bg">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-cream-gold leading-tight">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-cream-gold-light/80">
            {t('faq.subtitle')}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-2 border-burgundy rounded-2xl px-6 hover:border-cream-gold transition-colors duration-300 bg-dark-card"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-cream-gold hover:text-cream-gold-light py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-cream-gold-light/80 pb-6 leading-relaxed text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
